"use strict";

var React = require('react');

var PropTypes = require('prop-types');

var flattenDeep = require('lodash/flattenDeep');

var _require = require('../../../products/constants'),
    RESERVED_SIGNS = _require.RESERVED_SIGNS,
    WEDDING_SIGNS = _require.WEDDING_SIGNS,
    TABLE_NUMBERS = _require.TABLE_NUMBERS,
    RESERVED_SIGN_REPRINTS = _require.RESERVED_SIGN_REPRINTS;

var actualPaperTypes = [{
  value: 'White Shimmer',
  actual: 'Shine Pearl'
}, {
  value: 'White Cotton',
  actual: 'Mohawk Ultrawhite'
}, {
  value: 'Double Thick White Cotton',
  actual: 'Mohawk Ultrawhite'
}, {
  value: 'White Matte',
  actual: 'Mohawk Ultrawhite'
}, {
  value: 'Ivory Shimmer',
  actual: 'Shine Champagne/Ivory'
}, {
  value: 'Ivory Cotton',
  actual: 'Mohawk Ivory'
}, {
  value: 'Double Thick Ivory Cotton',
  actual: 'Mohawk Ivory'
}, {
  value: 'Ivory Matte',
  actual: 'Mohawk Ivory'
}, {
  value: 'Double Thick White Matte',
  actual: 'Mohawk Ultrawhite Layers DOUBLETHICK'
}, {
  value: 'Double Thick Ivory Matte',
  actual: 'Mohawk Ivory Layers DOUBLETHICK'
}];

function TableNumberComponent(_ref) {
  var product = _ref.product,
      component = _ref.component;
  var ink_colors = product.ink_colors,
      design_name = product.design_name,
      product_type = product.product_type;
  var quantity = component.quantity,
      orientation = component.orientation,
      queue = component.queue;
  var o = 'Error: No Orientation Found';

  if (orientation === 'L') {
    o = 'LANDSCAPE';
  } else if (orientation === 'P') {
    o = 'PORTRAIT';
  }

  var type = '';

  if (product_type === RESERVED_SIGNS) {
    type = 'Reserved';
  } else if (product_type === WEDDING_SIGNS) {
    type = 'Signs';
  }

  return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("strong", null, design_name), /*#__PURE__*/React.createElement("br", null), type, ink_colors.join(','), quantity, " - 2 Sets", /*#__PURE__*/React.createElement("br", null), o, /*#__PURE__*/React.createElement("br", null), "Queue: ", queue, /*#__PURE__*/React.createElement("br", null));
}

TableNumberComponent.propTypes = {
  product: PropTypes.shape({
    ink_colors: PropTypes.array.isRequired,
    design_name: PropTypes.string.isRequired,
    product_type: PropTypes.string.isRequired
  }).isRequired,
  component: PropTypes.shape({
    quantity: PropTypes.number.isRequired,
    orientation: PropTypes.oneOf(['P', 'L']).isRequired,
    queue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
  }).isRequired
};

function TableNumbersByPaperType(props) {
  var PrintJobs = props.PrintJobs,
      paperType = props.paperType;
  var sizes = {
    '5x7': [],
    '4x6': []
  };
  var should_include = false;
  flattenDeep(PrintJobs.map(function (_ref2) {
    var products = _ref2.products;
    return products;
  })).filter(function (_ref3) {
    var product_type = _ref3.product_type;
    return [RESERVED_SIGNS, RESERVED_SIGN_REPRINTS, // just in case.
    WEDDING_SIGNS, TABLE_NUMBERS].includes(product_type);
  }).filter(function (_ref4) {
    var paper_type = _ref4.paper_type;
    return paper_type === paperType;
  }).forEach(function (product, i1) {
    product.components.forEach(function (component, i2) {
      var el = /*#__PURE__*/React.createElement("div", {
        key: i1 + i2
      }, /*#__PURE__*/React.createElement(TableNumberComponent, {
        product: product,
        component: component
      }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null));
      sizes[component.product_size].push(el);
      should_include = true;
    });
  });

  if (should_include) {
    var actualPaperTypeObj = actualPaperTypes.find(function (_ref5) {
      var value = _ref5.value;
      return value === props.paperType;
    });
    var actualPaperType = actualPaperTypeObj ? actualPaperTypeObj.actual : props.paperType;
    return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("strong", null, actualPaperType.toUpperCase()), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), Object.keys(sizes).map(function (size, index) {
      var components = sizes[size]; // console.log(components);

      if (components.length === 0) {
        return null;
      }

      return /*#__PURE__*/React.createElement("span", {
        key: size + index
      }, "---".concat(size, "'---"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), components);
    }));
  }

  return null;
}

TableNumbersByPaperType.propTypes = {
  PrintJobs: PropTypes.array.isRequired,
  paperType: PropTypes.string.isRequired
};
module.exports = TableNumbersByPaperType;